
  import { Component, Mixins } from 'vue-property-decorator'
  import FormModal from '@/mixins/formModal'

  @Component
  export default class CopyRestaurantModal extends Mixins(FormModal) {

  }
